import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;

export class ZIDXLogin implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxLoginContainer";
    }
    render(){
        // console.log("Login");
        let self=this;
        let $form=$(".zidxLoginContainer", this.zidx.peakidxShadowRoot);
        $(".contactLoginForm", $form).on("submit", (event) => {
           event.preventDefault();
              const contactLoginEmail = $(".contactLoginEmail", $form).val();
              console.log("submit contact login contactLoginEmail", contactLoginEmail);
            let postObj= {
                "contactLoginEmail": contactLoginEmail as string,
                "redirectURL": document.referrer
            };
            let obj = {
                id: "ajaxSearchListView",
                method: "post",
                ignoreOldRequests: true,
                postObj: postObj,
                callback: function(r:string){
                    let rs=JSON.parse(r);
                    if(rs.success) {
                        if(rs.redirectURL && rs.redirectURL!="") {
                            // console.log("redirect to ", rs.redirectURL);
                            window.location.href = rs.redirectURL;
                        }else{
                            // console.log("contact login success, close modal");
                            // @ts-ignore
                            window.parent.zidxCloseAllModalWindows();
                        }
                    }else{
                        alert("Search failed, please try again later");
                    }
                },
                errorCallback: function(r:string){
                    alert("Search failed, please try again later");
                },
                url: this.zidx.options.siteDomain + "/login-send-hash/"
            };
            this.zidx.ajaxRequest(obj);

        });

    }
}